import { getData, postData } from "../../api";

export const getAllTransferData = async (
  page,
  per_page,
  search,
  name,
  from,
  to,
  state_id,
  city_id,
) => {
  try {
    let url = `/payment/transfer-payment`;

    if (page) {
      url += `?page=${page}`;
    }

    if (per_page) {
      url += `&per_page=${per_page}`;
    }

    if (search) {
      url += `&term=${search}`;
    }
    if (name) {
      url += `&name=${name}`;
    }

    if (from) {
      url += `&from=${from}`;
    }

    if (to) {
      url += `&to=${to}`;
    }

    if (state_id) {
      url += `&state_id=${state_id}`;
    }

    if (city_id) {
      url += `&city_id=${city_id}`;
    }

    return await getData(url);
  } catch (error) {
    console.error(error);
  }
};

export const TransferRejected = async (data) => {
  try {
    return await postData(`/payment/transfer-payment/rejected`, data);
  } catch (error) {
    console.error(error);
  }
};
